import { createLayoutObject } from "./storefrontPopupConstants"

const centerStyles = {
    bottom: "auto",
    right: "auto",
    top: "50%",
    left: "50%",
    height: '280px',
    maxHeight: '600px',
    minHeight: '300px',
    width: '400px',
    maxWidth: '600px',
    minWidth: '400px',
    transform: "translate(-50%, -50%)"
}

const defaultCenterAccentStyles = {
    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    backgroundImage: "",
    backgroundColor: "#fffff",
    color: "#000000",
    padding: "10px",
    borderRadius: "10px"
}

const defaultCenterCoreStyles = {
    fontFamily: "Open Sans",
    height: '300px',
    width: '500px',
    maxHeight: '600px',
    minHeight: '300px',
    maxWidth: '600px',
    minWidth: '400px',
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
}

const leftStyles = {
    bottom: "auto",
    right: "auto",
    top: "0",
    left: "0",
    transform: "translate(0, 0)",
    height: "100vh",
    maxHeight: "100vh",
    width: "450px",
    maxWidth: "1000px",
    minWidth: "300px"
}

const rightStyles = {
    right: "auto",
    bottom: "auto",
    top: "0",
    left: "100%",
    transform: "translate(-100%, 0)",
    height: "100vh",
    maxHeight: "100vh",
    minHeight: "100vh",
    width: "400px",
    minWidth: "200px",
    maxWidth: "1000px"
}

const topBarStyles = {
    width: "100%",
    minWidth: "100%",
    maxWidth: "100%",
    height: "300px",
    minHeight: "200px",
    maxHeight: "700px",
    bottom: "auto",
    left: "auto",
    top: "0",
    right: "0",
    transform: "translate(0, 0)",
}

const bottomBarStyles = {
    width: "100%",
    minWidth: "100%",
    maxWidth: "100%",
    height: "300px",
    minHeight: "200px",
    maxHeight: "700px",
    top: "auto",
    right: "auto",
    bottom: "0",
    left: "0",
    transform: "translate(0, 0)"
}

const rightStickyStyles = {
    height: "300px",
    maxHeight: "500px",
    minHeight: "250px",
    width: "200px",
    maxWidth: "500px",
    minWidth: "250px",
    transform: "translate(-20px, -10px)",
    left: "auto",
    top: "auto",
    bottom: "10px",
    right: "10px",
}

const leftStickyStyles = {
    height: "300px",
    maxHeight: "500px",
    minHeight: "250px",
    width: "200px",
    maxWidth: "500px",
    minWidth: "250px",
    transform: "translate(10px, -10px)",
    top: "auto",
    right: "auto",
    left: "10px",
    bottom: "10px"
}

const generateUniqueIdForPopupData = () => `popupItem-${Math.random().toString(36).substr(2, 9)}`;

export const storeFrontPopupData = [
    {
        layout: [
            createLayoutObject("text", { label: "New Collection", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { fontWeight: 400, fontSize: "18px" } }),
            createLayoutObject("spacing", { label: "New Space", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { height: "10px" } }),
            createLayoutObject("text", { label: "10% OFF", position: "left", id: generateUniqueIdForPopupData() }),
            createLayoutObject("spacing", { label: "New Space", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { height: "10px" } }),
            createLayoutObject("text", { label: "Get a discount on all items in your next order", position: "left", id: generateUniqueIdForPopupData() }),
            createLayoutObject("spacing", { label: "New Space", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { height: "10px" } }),
            createLayoutObject("coupon", { label: "Coupon Code", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { color: "green", fontWeight: "500", backgroundColor: "lightgreen", borderColor: "green" } }),
            createLayoutObject("spacing", { label: "New Space", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { height: "20px" } }),
            createLayoutObject("button", { label: "Shop Now", position: "left", id: generateUniqueIdForPopupData(), desktopStyles: { color: "blue", fontWeight: "500", backgroundColor: "#fff", borderColor: "blue", padding: "10px" } }),
            createLayoutObject("image", { label: "Image", position: "right", id: generateUniqueIdForPopupData(), desktopStyles: { height: "300px" } })
        ],
        layoutType: "2",
        layoutPadding: {
            "column": "0px",
            "column1": "20px",
            "column2": "0px"
        },
        desktopStyles: {
            ...defaultCenterAccentStyles,
            ...defaultCenterCoreStyles,
        },
        tabletlargeStyles: {
            ...defaultCenterCoreStyles,
            height: '300px',
            maxHeight: '768px',
            minHeight: '300px',
            width: '450px',
            maxWidth: '768px',
            minWidth: '300px',
        },
        tabletStyles: {
            ...defaultCenterCoreStyles,
            height: '300px',
            maxHeight: '768px',
            minHeight: '300px',
            width: '450px',
            maxWidth: '768px',
            minWidth: '300px',
        },
        mobilelargeStyles: {
            ...defaultCenterCoreStyles,
            height: '300px',
            maxHeight: '600px',
            minHeight: '300px',
            width: '400px',
            maxWidth: '600px',
            minWidth: '300px',
        },
        mobileStyles: {
            ...defaultCenterCoreStyles,
            height: '300px',
            maxHeight: '480px',
            minHeight: '300px',
            width: '320px',
            maxWidth: '480px',
            minWidth: '300px',
        },
        targetDevice: {
            desktop: true,
            tabletlarge: true,
            tablet: true,
            mobilelarge: true,
            mobile: true
        },
        showCloseButton: true,
        backdropColor: "#00000082",
        closeButtonColor: "#000",
        closeButtonBackgroundColor: "#e7e7e7f2",
        targetPage: "none",
        position: "center",
        trigger: "none",
        sticky: false,
        name: "Popup",
        id: 1
    },
]

export const StorefrontPopupPositionSettings = {
    center: {
        desktopStyles: centerStyles,
        tabletlargeStyles: {
            ...centerStyles,
            height: '400px',
            maxHeight: '992px',
            minHeight: '300px',
            width: '400px',
            maxWidth: '992px',
            minWidth: '300px',
        },
        tabletStyles: {
            ...centerStyles,
            height: '400px',
            maxHeight: '768px',
            minHeight: '300px',
            width: '400px',
            maxWidth: '768px',
            minWidth: '300px',
        },
        mobilelargeStyles: {
            ...centerStyles,
            height: '400px',
            maxHeight: '600px',
            minHeight: '300px',
            width: '400px',
            maxWidth: '600px',
            minWidth: '300px',
        },
        mobileStyles: {
            ...centerStyles,
            height: '400px',
            maxHeight: '480px',
            minHeight: '300px',
            width: '400px',
            maxWidth: '480px',
            minWidth: '300px',
        }
    },
    left: {
        desktopStyles: leftStyles,
        tabletlargeStyles: {
            ...leftStyles,
            width: "450px",
            maxWidth: "992px"
        },
        tabletStyles: {
            ...leftStyles,
            width: "400px",
            maxWidth: "768px"
        },
        mobilelargeStyles: {
            ...leftStyles,
            width: "400px",
            maxWidth: "600px"
        },
        mobileStyles: {
            ...leftStyles,
            width: "300px",
            maxWidth: "480px",
            minWidth: "280px"
        },
    },
    right: {
        desktopStyles: rightStyles,
        tabletlargeStyles: {
            ...rightStyles,
            width: "450px",
            maxWidth: "992px"
        },
        tabletStyles: {
            ...rightStyles,
            width: "400px",
            maxWidth: "768px"
        },
        mobilelargeStyles: {
            ...rightStyles,
            width: "400px",
            maxWidth: "600px"
        },
        mobileStyles: {
            ...rightStyles,
            width: "300px",
            maxWidth: "480px",
            minWidth: "280px"
        },
    },
    topBar: {
        desktopStyles: topBarStyles,
        tabletlargeStyles: {
            ...topBarStyles,
            height: "300px",
            maxHeight: "600px",
        },
        tabletStyles: {
            ...topBarStyles,
            height: "300px",
            maxHeight: "500px",
        },
        mobilelargeStyles: {
            ...topBarStyles,
            height: "300px",
            maxHeight: "400px",
        },
        mobileStyles: {
            ...topBarStyles,
            height: "300px",
            maxHeight: "300px",
            minHeight: "200px"
        },
    },
    bottomBar: {
        desktopStyles: bottomBarStyles,
        tabletlargeStyles: {
            ...bottomBarStyles,
            height: "300px",
            maxHeight: "600px",
        },
        tabletStyles: {
            ...bottomBarStyles,
            height: "300px",
            maxHeight: "500px",
        },
        mobilelargeStyles: {
            ...bottomBarStyles,
            height: "300px",
            maxHeight: "400px",
        },
        mobileStyles: {
            ...bottomBarStyles,
            height: "300px",
            maxHeight: "300px",
            minHeight: "200px"
        },
    },
    leftSticky: {
        desktopStyles: leftStickyStyles,
        tabletlargeStyles: {
            ...leftStickyStyles,
            height: "280px",
            maxHeight: "400px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "400px",
            minWidth: "250px",
        },
        tabletStyles: {
            ...leftStickyStyles,
            height: "280px",
            maxHeight: "350px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "350px",
            minWidth: "250px",
        },
        mobilelargeStyles: {
            ...leftStickyStyles,
            height: "280px",
            maxHeight: "300px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "300px",
            minWidth: "250px",
        },
        mobileStyles: {
            ...leftStickyStyles,
            height: "280px",
            maxHeight: "300px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "300px",
            minWidth: "250px",
        },
    },
    rightSticky: {
        desktopStyles: rightStickyStyles,
        tabletlargeStyles: {
            ...rightStickyStyles,
            height: "280px",
            maxHeight: "400px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "400px",
            minWidth: "250px",
        },
        tabletStyles: {
            ...rightStickyStyles,
            height: "280px",
            maxHeight: "350px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "350px",
            minWidth: "250px",
        },
        mobilelargeStyles: {
            ...rightStickyStyles,
            height: "280px",
            maxHeight: "300px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "300px",
            minWidth: "250px",
        },
        mobileStyles: {
            ...rightStickyStyles,
            height: "280px",
            maxHeight: "300px",
            minHeight: "250px",
            width: "200px",
            maxWidth: "300px",
            minWidth: "250px",
        },
    }
}
